import { HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { hasProp, propEquals } from '@shared/utils';
import { catchError, map, of } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { ErrorPageReasons } from '../shared/constants';

export const configGuard = (configService: ConfigService, router: Router, redirect: string | undefined): MaybeAsync<GuardResult> => {
    return configService.getIxlabFrontendConfig().pipe(
        map(() => true),
        catchError((error: unknown) => {
            if (!(hasProp(error, 'error') && hasProp(error.error, 'data'))) {
                return of(router.createUrlTree(['error'], { queryParams: { redirect } }));
            }

            // TODO: Schon im Backend Fehlerart feststellen und in message mitliefern

            if (propEquals(error.error.data, 'statusCode', HttpStatusCode.Forbidden)) {
                return of(router.createUrlTree(['error'], { queryParams: { reason: ErrorPageReasons.Practice, redirect } }));
            }

            if (
                propEquals(error, 'code', HttpStatusCode.Unauthorized) &&
                hasProp(error.error.data, 'message') &&
                typeof error.error.data.message === 'string'
            ) {
                return of(
                    router.createUrlTree(['error'], {
                        queryParams: { reason: ErrorPageReasons.CustomMessage, msg: error.error.data.message, redirect },
                    }),
                );
            }

            return of(router.createUrlTree(['error'], { queryParams: { redirect } }));
        }),
    );
};

export const configCanMatchFn: CanMatchFn = () => {
    const router = inject(Router);
    const configService = inject(ConfigService);

    const redirect = router.getCurrentNavigation()?.extractedUrl.toString();

    return configGuard(configService, router, redirect);
};

export const configCanActivateFn: CanActivateFn = (_, state) => {
    const router = inject(Router);
    const configService = inject(ConfigService);

    const redirect = state.url;

    return configGuard(configService, router, redirect);
};
